import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'semantic-ui-react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
import connect from 'react-redux/es/connect/connect';
import ButtonWrapper from '../../common/ButtonWrapper';
import { compareRowsModalActions } from '../../../behavior/compareRowsModal';
import OverviewTableCell from './OverviewTableCell';
import { Loading } from 'react-lib/dist/components-es';

export const CompareRowsModalTrigger = ({ onClick, label, disabled }) => {
  return (
    <ButtonWrapper
      key={label}
      type="button"
      label={label}
      icon="exchange"
      primary
      onClick={onClick}
      disabled={disabled}
    />
  );
};

CompareRowsModalTrigger.propTypes = { onClick: PropTypes.func.isRequired };

const CompareRowsModal = ({
  open,
  toggleModal,
  selectedRows,
  getFullRows,
  entityType,
  fullRows,
  hazardList,
  visibleColumns,
  actions,
  disabled,
  isLoading,
  label,
  title,
  description,
}) => {
  useEffect(() => {
    if (open) getFullRows(Object.keys(selectedRows), entityType);
  }, [open]);

  const atLeastOneIsDif = (r, k) => fullRows.some(nr => nr[k] != r[k]);

  return (
    <Modal
      trigger={
        <CompareRowsModalTrigger
          onClick={() => toggleModal(true)}
          label={t(label)}
          disabled={disabled}
        />
      }
      centered={true}
      open={open}
      onClose={() => toggleModal(false)}
      size="large"
      closeIcon={true}
    >
      <Modal.Header>{t(title)}</Modal.Header>
      <Modal.Content scrolling>
        <Loading isLoading={isLoading} />
        {t(description)}
        <Table definition className="compareRowsModal">
          <Table.Body>
            {visibleColumns
              .filter(k => fullRows.some(r => atLeastOneIsDif(r, k.value)))
              .map(k => (
                <Table.Row key={'compareRowsModalRow' + k.value}>
                  {fullRows.map((r, i) => (
                    <React.Fragment key={'compareRowsModalRowCells' + k.value + i}>
                      {i == 0 ? (
                        <Table.Cell key={'tableCell' + k.label}>{t(k.label)}</Table.Cell>
                      ) : null}
                      <OverviewTableCell
                        actions={actions}
                        rowCount={i}
                        rowValues={r}
                        displayTableOptions={[]}
                        visibleColumns={[k]}
                        hazardList={hazardList}
                        entityTypeProps={entityType}
                        handleFilterStateChanged={() => {}}
                        handleDefaultFilteredListOverride={() => {}}
                        entityType={entityType}
                      />
                    </React.Fragment>
                  ))}
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </Modal.Content>
    </Modal>
  );
};

CompareRowsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  selectedRows: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  entityType: PropTypes.string.isRequired,
  visibleColumns: PropTypes.array.isRequired,
  hazardList: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
};

CompareRowsModal.defaultProps = {
  label: 'compare.rows.modal.trigger.label',
  title: 'compare.rows.modal.title',
  description: 'compare.rows.modal.description',
  disabled: true,
  isLoading: false,
};

const mapStateToProps = state => ({
  ...state.compareRowsModal,
});

const mapDispatchToProps = dispatch => ({
  getFullRows: (ids, entityType) => dispatch(compareRowsModalActions.getFullRows(ids, entityType)),
  toggleModal: state => dispatch(compareRowsModalActions.toggle(state)),
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(CompareRowsModal);
